<template>
  <section class="py-20 bg-gradient-to-br from-slate-700 to-slate-900 relative overflow-hidden">

    <PatternNew class="absolute top-0 left-0 w-full" :columns="10" :rows="9" variant="outline"
      outlineClass="border-gray-700" :isAnimated="true" />

    <ContentWrapper class="relative z-10">
      <!-- Section Header -->

      <SectionHeader subheader="Built for Trust" :isReverse="true" :isCentered="true"
        title="Enterprise-Grade Security You Can Rely On"         />

      <div class="text-xl text-gray-200 max-w-3xl mx-auto text-center mt-4">
        Data integrity and security at the forefront of everything we do. Your event data is protected by
        industry-leading security standards.
      </div>


      <!-- Main Content Grid -->
      <div class="grid lg:grid-cols-2 gap-12 items-center my-16">
        <!-- Image Section -->
        <div class="order-2 lg:order-1">
          <div class="relative rounded-tl-4xl rounded-br-4xl overflow-hidden shadow-2xl border-gray-500 border">
            <img src="../images/photography/entegy01.jpg" alt="Secure cloud infrastructure"
              class="w-full h-auto object-cover" />
          </div>
        </div>


        <div class="order-1 lg:order-2">
          <FeatureStep iconVariant="accent" :isReverse="true" :icon="ShieldCheckIcon" title="ISO 27001 Certified" description="Our information security management system meets the internationally recognized ISO 27001 standard, ensuring the highest level of data protection and privacy." />
          <FeatureStep iconVariant="accent" :isReverse="true" :icon="ShieldCheckIcon" title="AWS Infrastructure" description="Hosted on Amazon Web Services, the world's most secure and reliable cloud platform. Benefit from enterprise-grade redundancy, automatic backups, and 99.99% uptime SLA." />
          <FeatureStep iconVariant="accent" :isReverse="true" :icon="ShieldCheckIcon" title="Data Encryption" description="End-to-end encryption for data in transit and at rest. Your sensitive event data is protected with AES-256 encryption and TLS 1.3 protocols." />
        </div>

      </div>

      <!-- Security Features Grid -->
      <div class="grid md:grid-cols-3 gap-8">
        <div class="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
          
          <h4 class="text-xl font-semibold text-secondary-900 mb-2">Regular Security Audits</h4>
          <p class="text-gray-500 text-sm mt-2">
            Continuous monitoring and regular third-party security audits to ensure compliance and identify potential
            vulnerabilities.
          </p>
        </div>

        <div class="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
          
          <h4 class="text-xl font-semibold text-secondary-900 mb-2">GDPR Compliant</h4>
          <p class="text-gray-500 text-sm mt-2">
            Full compliance with GDPR and international data protection regulations, giving you and your attendees peace
            of mind.
          </p>
        </div>

        <div class="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
          
          <h4 class="text-xl font-semibold text-secondary-900 mb-2">24/7 Monitoring</h4>
          <p class="text-gray-500 text-sm mt-2">
            Round-the-clock infrastructure monitoring and automated threat detection to keep your data safe at all
            times.
          </p>
        </div>
      </div>

    </ContentWrapper>
  </section>
</template>

<script setup>
import {
  CreditCardIcon,
  GlobeAltIcon,
  PhoneIcon,
  UserGroupIcon,
  EnvelopeIcon,
  VideoCameraIcon,
  ClipboardDocumentIcon,
  Bars3Icon,
  QrCodeIcon,
  MapIcon,
  MicrophoneIcon,
  BuildingOfficeIcon,
  Squares2X2Icon,
  CodeBracketIcon,
  BuildingOffice2Icon,
  ShieldCheckIcon,
  MagnifyingGlassIcon,
  UserPlusIcon,
  AcademicCapIcon,
  BriefcaseIcon
} from '@heroicons/vue/24/outline'

import ContentWrapper from './Layouts/ContentWrapper.vue';
import SectionHeader from './Layouts/SectionHeader.vue';
import PatternNew from './PatternNew.vue';
import FeatureStep from './Layouts/FeatureStep.vue';

// Data Security Component
</script>
